import React, { useState } from 'react';
import { Button } from './ui/button';
import { isNativePlatform } from '../lib/native';
import { isWebAppleEnabled, isWebGoogleEnabled, getAppleWebCredential } from '../lib/webIdentity';
import { useProviderSignIn } from '../hooks/useProviderSignIn';
import AccountChoiceDialog from './AccountChoiceDialog';
import GoogleWebButton from './GoogleWebButton';

const AppleGlyph = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M17.564 12.658c-.021-2.198 1.798-3.256 1.881-3.308-1.026-1.5-2.62-1.706-3.19-1.73-1.358-.137-2.653.8-3.343.8-.69 0-1.756-.78-2.888-.759-1.486.022-2.856.86-3.62 2.184-1.542 2.668-.394 6.617 1.108 8.784.734 1.056 1.61 2.24 2.762 2.199 1.108-.045 1.527-.717 2.866-.717 1.338 0 1.716.717 2.888.696 1.19-.022 1.945-1.072 2.675-2.132.842-1.222 1.19-2.407 1.212-2.468-.026-.012-2.325-.892-2.351-3.549zM15.383 5.86c.612-.741 1.023-1.769.911-2.797-.881.035-1.947.586-2.579 1.327-.567.657-1.062 1.706-.929 2.713.982.076 1.985-.5 2.597-1.243z" />
  </svg>
);

// Website Apple + Google buttons; each appears only once its client ID is configured.
export const WebProviderButtons = ({ redirectTo = '/dashboard' }) => {
  const [loading, setLoading] = useState(false);
  const { signIn, pending, busy, confirmCreate, chooseExisting } = useProviderSignIn(redirectTo);
  const showApple = isWebAppleEnabled();
  const showGoogle = isWebGoogleEnabled();
  if (isNativePlatform() || (!showApple && !showGoogle)) return null;

  const handleApple = async () => {
    setLoading(true);
    await signIn('apple', () => getAppleWebCredential());
    setLoading(false);
  };

  return (
    <div className="w-full space-y-3 mb-6" data-testid="web-provider-buttons">
      {showApple && (
        <Button
          type="button"
          onClick={handleApple}
          disabled={loading}
          className="w-full bg-black text-white hover:bg-[#111] rounded-2xl py-6 flex items-center justify-center gap-3 border border-white/10"
          data-testid="apple-web-signin-btn"
        >
          <AppleGlyph />
          <span className="font-sans font-medium">{loading ? 'Opening Apple…' : 'Continue with Apple'}</span>
        </Button>
      )}
      {showGoogle && (
        <GoogleWebButton onCredential={(cred) => signIn('google', async () => cred)} testId="google-web-signin-btn" />
      )}
      <AccountChoiceDialog
        provider={pending?.provider}
        open={!!pending}
        busy={busy}
        onCreate={confirmCreate}
        onExisting={chooseExisting}
      />
    </div>
  );
};

export default WebProviderButtons;
